export default __webpack_public_path__ + "static/media/greiffStrick.2243b509.jpg";